/* cp-mirror.js — halo de lumière sous les grands titres, comme le sol brillant sous les crampons du hero.
   Volontairement très flouté : on ne doit jamais relire le texte à l'envers, seulement la lumière. */
(function(){
  'use strict';

  var CSS = ''
    + '.dsp{position:relative}'
    + '.dsp[data-mir]{margin-bottom:calc(.58em + 24px)}'
    + '.cp-mir{position:absolute;left:-8%;right:-8%;top:calc(100% + 2px);height:.58em;overflow:hidden;'
    +   'transform:scaleY(-.42);transform-origin:center center;'
    +   'pointer-events:none;user-select:none;z-index:0;filter:blur(13px) saturate(1.25);opacity:.62;'
    +   '-webkit-mask-image:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,.40) 52%,rgba(0,0,0,1) 100%);'
    +   'mask-image:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,.40) 52%,rgba(0,0,0,1) 100%)}'
    + '.cp-mir > .cp-mirin{position:absolute;left:7.15%;right:7.15%;bottom:0;display:block;margin:0;padding:0;border:0;'
    +   'font:inherit;letter-spacing:inherit;line-height:inherit;text-align:inherit;color:inherit;white-space:inherit}'
    + '.hero .dsp[data-mir]{margin-bottom:calc(.54em + 26px)}'
    + '.hero .cp-mir{height:.54em;opacity:.52;filter:blur(14px) saturate(1.25)}'
    + '@media (max-width:900px){'
    +   '.dsp[data-mir]{margin-bottom:calc(.52em + 15px)}'
    +   '.cp-mir{height:.52em;filter:blur(8px) saturate(1.25);opacity:.58}'
    +   '.hero .dsp[data-mir]{margin-bottom:calc(.50em + 15px)}.hero .cp-mir{height:.48em;filter:blur(9px) saturate(1.25)}}';

  function style(){
    if(document.getElementById('cp-mir-css')) return;
    var s = document.createElement('style');
    s.id = 'cp-mir-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function build(t){
    if(t.getAttribute('data-mir')) return;
    if(!t.textContent.trim()) return;
    if(t.closest('.cpsoc-band')) return;      /* bande sombre : pas de halo */

    var box = document.createElement('span');
    box.className = 'cp-mir';
    box.setAttribute('aria-hidden','true');

    var inner = document.createElement('span');
    inner.className = 'cp-mirin';
    for(var i=0;i<t.childNodes.length;i++){
      var c = t.childNodes[i].cloneNode(true);
      if(c.nodeType === 1){ c.removeAttribute('id'); c.removeAttribute('class'); }
      inner.appendChild(c);
    }
    inner.querySelectorAll('em').forEach(function(e){ e.className = ''; });

    box.appendChild(inner);
    t.appendChild(box);
    t.setAttribute('data-mir','1');
  }

  function scan(){
    style();
    document.querySelectorAll('.dsp').forEach(function(t){
      if(t.querySelector('.cp-mir')) return;
      build(t);
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.addEventListener('load', scan);
  setTimeout(scan, 1200);
  setTimeout(scan, 3000);
})();
